'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const EmailVerificationBanner = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 5px;
  background-color: ${colors.secondary.blue1};
`;
